import { render, staticRenderFns } from "./DetailSelectModal.vue?vue&type=template&id=089b8d6a&"
import script from "./DetailSelectModal.vue?vue&type=script&lang=js&"
export * from "./DetailSelectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports